import styled from 'styled-components'
import ArrowSvg from 'resources/svg/icons/caret-down.svg'
import { link } from 'app/sofia/resources/theme/css'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { h1Css } from 'app/sofia/components/Structure/Title'
import { BP } from 'resources/constants'
import { bp } from 'lib/core/resources/helpers/styled'

export const Section = styled.section`
  ${sectionCss}
`
export const Container = styled.div`
  ${containerCss}

  h1 {
    ${h1Css}
  }
`
export const TableHeader = styled.div`
  padding: 10px 12px;
  background: ${props => props.theme.palette.general.greyLight};
  font-weight: 600;
`

export const CartLayout = styled.div`
  @media (min-width: ${BP.sm.min}) {
    display: flex;
  }

  > * {
    box-sizing: border-box;
  }

  .cart-main {
    @media (min-width: ${BP.sm.min}) {
      width: calc(100% - 260px);
      padding: 0 30px 0 0;
    }
  }

  .cart-aside {
    margin-top: 20px;

    @media (min-width: ${BP.sm.min}) {
      margin-top: 0;
      position: sticky;
      top: 20px;
      width: 260px;
    }
  }
`

export const LinkWrapper = styled.div`
  a {
    ${link}
    display: inline-block;
    text-decoration: none;
    padding: 15px 0 0;
    font-weight: 600;
  }
`

export const QtyWrapper = styled.div`
  position: relative;
  ${bp('sm', 'min-width')`
    &::after,
    &::before {
      content: '';
      position: absolute;
      right: 10px;
      width: 20px;
      height: 20px;
      pointer-events: none;
      background: #fff url(${ArrowSvg}) center no-repeat;
      background-size: contain;
    }
  `}

  &::after {
    margin-top: 6px;
    transform: rotate(180deg);
  }

  &::before {
    margin-bottom: 6px;
    bottom: 0;
  }
`
